/*
 * Shared behavior for the default and IZZ product templates.
 * Keep parser-time sizing and purchase controllers in their sections.
 */

  document.addEventListener('DOMContentLoaded', function () {
    var carousel = document.querySelector('.custom-carousel');
    if (!carousel) return;

    var track = carousel.querySelector('.carousel-track');
    if (!track) return;

    var slides = Array.from(carousel.querySelectorAll('.carousel-slide'));
    var prevBtn = carousel.querySelector('.carousel-arrow--prev');
    var nextBtn = carousel.querySelector('.carousel-arrow--next');
    var thumbnails = document.querySelectorAll('.product-thumbnail');
    var previewThumbnails = document.querySelectorAll('.preview-thumbnail');
    var dots = document.querySelectorAll('.carousel-dot');
    var productDetails = document.querySelector('.product-details');
    var galleryWrapper = document.querySelector('.product-gallery-wrapper');
    var thumbnailsWrapper = document.querySelector('.product-thumbnails-wrapper');
    var thumbnailRail = document.querySelector('.product-thumbnails--draggable');

    var totalSlides = slides.length;
    var currentIndex = 0;
    var slidesPerView = window.innerWidth > 1364 ? 2 : 1;
    var isAnimating = false;
    var isThumbnailDragging = false;
    var thumbnailDragMoved = false;
    var thumbnailDragStartX = 0;
    var thumbnailDragStartScrollLeft = 0;
    var suppressThumbnailClick = false;
    var slideImageLoads = new Array(totalSlides);
    var remainingGalleryLoadStarted = false;
    var initialNearbyWarmupStarted = false;
    var activeAnimationTargetIndex = null;
    var pendingNavigation = null;

    // Drag state
    var isDragging = false;
    var startX = 0;
    var dragStartTime = 0;

    // If only 1 image, hide arrows and thumbnails, show full width
    if (totalSlides === 0) return;

    if (totalSlides === 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (thumbnailsWrapper) {
        thumbnailsWrapper.style.display = 'none';
      }
      slides[0].style.display = 'flex';
      slides[0].classList.add('single-image');
      track.style.justifyContent = 'center';
      syncHeights();
      return;
    }

    function normalizeSlideIndex(index) {
      return (index + totalSlides) % totalSlides;
    }

    function getSlideImage(index) {
      const slide = slides[normalizeSlideIndex(index)];
      return slide ? slide.querySelector('img') : null;
    }

    function isSlideImageReady(image) {
      return Boolean(image && image.complete && image.naturalWidth > 0);
    }

    function setSlideImagePriority(image, priority) {
      if (!image) return;

      if (image.getAttribute('fetchpriority') === 'high' && priority !== 'high') {
        return;
      }

      image.setAttribute('fetchpriority', priority);
      if ('fetchPriority' in image) {
        image.fetchPriority = priority;
      }
    }

    function decodeSlideImage(image) {
      if (!image || typeof image.decode !== 'function') {
        return Promise.resolve();
      }

      return image.decode().catch(function () {
        // A successful load is still usable when decode() is unavailable or rejects.
      });
    }

    function loadSlideImage(index, priority = 'low') {
      const normalizedIndex = normalizeSlideIndex(index);
      const image = getSlideImage(normalizedIndex);

      if (!image) {
        return Promise.resolve(true);
      }

      setSlideImagePriority(image, priority);
      const shouldRetry = image.getAttribute('data-gallery-load-failed') === 'true';

      if (isSlideImageReady(image)) {
        image.removeAttribute('data-gallery-load-failed');
        return decodeSlideImage(image).then(function () {
          return true;
        });
      }

      if (slideImageLoads[normalizedIndex]) {
        return slideImageLoads[normalizedIndex];
      }

      slideImageLoads[normalizedIndex] = new Promise(function (resolve) {
        var isSettled = false;

        function cleanup() {
          image.removeEventListener('load', handleLoad);
          image.removeEventListener('error', handleError);
        }

        function finish(success) {
          if (isSettled) return;

          isSettled = true;
          cleanup();

          if (!success) {
            image.setAttribute('loading', 'lazy');
            image.removeAttribute('fetchpriority');
            image.setAttribute('data-gallery-load-failed', 'true');
            slideImageLoads[normalizedIndex] = null;
            resolve(false);
            return;
          }

          image.removeAttribute('data-gallery-load-failed');
          decodeSlideImage(image).then(function () {
            resolve(true);
          });
        }

        function handleLoad() {
          finish(isSlideImageReady(image));
        }

        function handleError() {
          finish(false);
        }

        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        image.setAttribute('loading', 'eager');

        if ('loading' in image) {
          image.loading = 'eager';
        }

        if (shouldRetry) {
          const imageSrc = image.getAttribute('src');
          const imageSrcset = image.getAttribute('srcset');

          image.removeAttribute('src');
          image.removeAttribute('srcset');

          if (imageSrcset) image.setAttribute('srcset', imageSrcset);
          if (imageSrc) image.setAttribute('src', imageSrc);
          if (!imageSrc && !imageSrcset) finish(false);
        } else if (image.complete) {
          finish(isSlideImageReady(image));
        }
      });

      return slideImageLoads[normalizedIndex];
    }

    function getNearbySlideIndexes(index, radius = 3) {
      if (totalSlides < 2 || radius < 1) return [];

      const centerIndex = normalizeSlideIndex(index);
      const nearbyIndexes = [];
      const seenIndexes = new Set([centerIndex]);
      const maxRadius = Math.min(radius, totalSlides - 1);

      for (let offset = 1; offset <= maxRadius; offset += 1) {
        const nextIndex = normalizeSlideIndex(centerIndex + offset);
        const previousIndex = normalizeSlideIndex(centerIndex - offset);

        if (!seenIndexes.has(nextIndex)) {
          seenIndexes.add(nextIndex);
          nearbyIndexes.push(nextIndex);
        }
        if (!seenIndexes.has(previousIndex)) {
          seenIndexes.add(previousIndex);
          nearbyIndexes.push(previousIndex);
        }
      }

      return nearbyIndexes;
    }

    function preloadNearbySlides(index, radius = 3, priority = 'low') {
      getNearbySlideIndexes(index, radius).forEach(function (nearbyIndex) {
        loadSlideImage(nearbyIndex, priority);
      });
    }

    function preloadAdjacentSlides(index, priority = 'low') {
      preloadNearbySlides(index, 1, priority);
    }

    function warmInitialNearbySlides() {
      if (initialNearbyWarmupStarted) return;

      initialNearbyWarmupStarted = true;
      preloadNearbySlides(currentIndex, 3, 'low');
    }

    function prepareInitialNearbyWarmup() {
      const initialImage = getSlideImage(0);

      if (!initialImage) {
        warmInitialNearbySlides();
        return;
      }

      function finishInitialNearbyWarmup() {
        initialImage.removeEventListener('load', finishInitialNearbyWarmup);
        initialImage.removeEventListener('error', finishInitialNearbyWarmup);

        if (isSlideImageReady(initialImage)) {
          decodeSlideImage(initialImage).then(warmInitialNearbySlides);
        } else {
          warmInitialNearbySlides();
        }
      }

      if (initialImage.complete) {
        finishInitialNearbyWarmup();
        return;
      }

      initialImage.addEventListener('load', finishInitialNearbyWarmup);
      initialImage.addEventListener('error', finishInitialNearbyWarmup);
    }

    function scheduleIdleGalleryTask(callback) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 1500 });
      } else {
        window.setTimeout(callback, 250);
      }
    }

    function loadRemainingGalleryImagesOneByOne() {
      if (remainingGalleryLoadStarted || totalSlides < 2) return;

      remainingGalleryLoadStarted = true;
      const remainingIndexes = getNearbySlideIndexes(currentIndex, totalSlides - 1);

      function loadNextImage() {
        if (!remainingIndexes.length) return;

        scheduleIdleGalleryTask(function () {
          const nextIndex = remainingIndexes.shift();
          loadSlideImage(nextIndex, 'low').then(loadNextImage);
        });
      }

      loadNextImage();
    }

    function addSlideIntentListeners(element, getIndex) {
      if (!element) return;

      function preloadTarget() {
        if (isAnimating) return;
        loadSlideImage(getIndex(), 'high');
      }

      element.addEventListener('mouseenter', preloadTarget);
      element.addEventListener('touchstart', preloadTarget, { passive: true });
    }

    function syncHeights() {
      if (window.innerWidth >= 992 && productDetails && galleryWrapper) {
        setHeight();
      } else if (productDetails) {
        productDetails.style.maxHeight = 'none';
        document.documentElement.style.removeProperty('--carousel-height');
      }
    }

    function setHeight() {
      if (window.innerWidth >= 992 && galleryWrapper && productDetails) {
        const carouselHeight = galleryWrapper.offsetHeight;
        if (!carouselHeight) return;

        const nextHeight = carouselHeight + 'px';
        if (document.documentElement.style.getPropertyValue('--carousel-height') !== nextHeight) {
          document.documentElement.style.setProperty('--carousel-height', nextHeight);
        }
        if (window.getComputedStyle(productDetails).maxHeight !== nextHeight) {
          productDetails.style.maxHeight = nextHeight;
        }
      }
    }

    function getLeftIndex(rightIndex) {
      return (rightIndex - 1 + totalSlides) % totalSlides;
    }

    function updateSlides() {
      slidesPerView = window.innerWidth > 1364 ? 2 : 1;
      const leftIndex = getLeftIndex(currentIndex);

      if (slidesPerView === 1) {
        // Mobile
        track.style.transition = 'none';
        track.style.transform = 'none';
        slides.forEach((slide, index) => {
          slide.style.display = index === currentIndex ? 'flex' : 'none';
          slide.style.width = '100%';
          slide.style.order = '0';
        });
      } else {
        // Desktop - show/hide approach for static state (40:60 ratio)
        track.style.transition = 'none';
        track.style.transform = 'none';
        slides.forEach((slide, index) => {
          slide.classList.remove('is-visible-left', 'is-visible-right');
          if (index === leftIndex) {
            slide.style.display = 'flex';
            slide.style.width = '40%';
            slide.style.order = '1';
            slide.classList.add('is-visible-left');
          } else if (index === currentIndex) {
            slide.style.display = 'flex';
            slide.style.width = '60%';
            slide.style.order = '2';
            slide.classList.add('is-visible-right');
          } else {
            slide.style.display = 'none';
            slide.style.order = '0';
          }
        });
      }

      updateThumbnails();
      preloadAdjacentSlides(currentIndex, 'low');
    }

    function animateToSlide(newIndex, direction) {
      if (isAnimating || slidesPerView === 1) {
        currentIndex = newIndex;
        updateSlides();
        return;
      }

      isAnimating = true;
      activeAnimationTargetIndex = newIndex;

      const oldLeftIndex = getLeftIndex(currentIndex);
      const newLeftIndex = getLeftIndex(newIndex);

      slides.forEach((slide) => {
        slide.style.display = 'none';
        slide.style.transition = 'none';
      });

      if (direction === 'next') {
        // Animation for next: 40:60 ratio
        slides[oldLeftIndex].style.display = 'flex';
        slides[oldLeftIndex].style.width = '40%';
        slides[oldLeftIndex].style.order = '1';

        slides[currentIndex].style.display = 'flex';
        slides[currentIndex].style.width = '30%';
        slides[currentIndex].style.order = '2';

        slides[newIndex].style.display = 'flex';
        slides[newIndex].style.width = '60%';
        slides[newIndex].style.order = '3';

        track.style.transition = 'none';
        track.style.transform = 'translateX(0%)';

        track.offsetHeight;

        track.style.transition = 'transform 0.4s ease-out';
        track.style.transform = 'translateX(-40%)';
      } else {
        // Animation for prev: 40:60 ratio
        slides[newLeftIndex].style.display = 'flex';
        slides[newLeftIndex].style.width = '40%';
        slides[newLeftIndex].style.order = '1';

        slides[newIndex].style.display = 'flex';
        slides[newIndex].style.width = '30%';
        slides[newIndex].style.order = '2';

        slides[currentIndex].style.display = 'flex';
        slides[currentIndex].style.width = '60%';
        slides[currentIndex].style.order = '3';

        track.style.transition = 'none';
        track.style.transform = 'translateX(-40%)';

        track.offsetHeight;

        track.style.transition = 'transform 0.4s ease-out';
        track.style.transform = 'translateX(0%)';
      }

      setTimeout(() => {
        currentIndex = newIndex;
        updateSlides();
        isAnimating = false;
        activeAnimationTargetIndex = null;
        runPendingNavigation();
      }, 420);
    }

    function getNavigationBaseIndex() {
      if (pendingNavigation) return pendingNavigation.index;
      if (activeAnimationTargetIndex !== null) return activeAnimationTargetIndex;
      return currentIndex;
    }

    function runPendingNavigation() {
      if (!pendingNavigation) return;

      const navigation = pendingNavigation;
      pendingNavigation = null;

      if (navigation.index !== currentIndex) {
        goToSlide(navigation.index, navigation.animate, navigation.directionOverride);
      }
    }

    function goToSlide(index, animate = true, directionOverride = null) {
      const newIndex = normalizeSlideIndex(index);

      if (isAnimating) {
        loadSlideImage(newIndex, 'high');
        preloadNearbySlides(newIndex, 3, 'low');
        pendingNavigation = {
          index: newIndex,
          animate: animate,
          directionOverride: directionOverride
        };
        return;
      }

      if (newIndex === currentIndex) return;

      loadSlideImage(newIndex, 'high');
      preloadNearbySlides(newIndex, 3, 'low');
      slidesPerView = window.innerWidth > 1364 ? 2 : 1;

      if (animate && slidesPerView === 2) {
        const forwardDist = (newIndex - currentIndex + totalSlides) % totalSlides;
        const backwardDist = (currentIndex - newIndex + totalSlides) % totalSlides;
        const direction = directionOverride || (forwardDist <= backwardDist ? 'next' : 'prev');
        animateToSlide(newIndex, direction);
      } else {
        currentIndex = newIndex;
        updateSlides();
      }
    }

    function nextSlide() {
      const newIndex = normalizeSlideIndex(getNavigationBaseIndex() + 1);
      goToSlide(newIndex, true, 'next');
    }

    function prevSlide() {
      const newIndex = normalizeSlideIndex(getNavigationBaseIndex() - 1);
      goToSlide(newIndex, true, 'prev');
    }

    function scrollActiveThumbnailIntoView() {
      if (!thumbnailsWrapper || thumbnailsWrapper.classList.contains('is-collapsed') || window.innerWidth <= 991) return;

      const activeThumbnail = thumbnails[currentIndex];
      const thumbnailRail = activeThumbnail ? activeThumbnail.parentElement : null;
      if (!activeThumbnail || !thumbnailRail || thumbnailRail.scrollWidth <= thumbnailRail.clientWidth) return;

      const railRect = thumbnailRail.getBoundingClientRect();
      const thumbRect = activeThumbnail.getBoundingClientRect();

      if (thumbRect.left < railRect.left) {
        thumbnailRail.scrollLeft -= railRect.left - thumbRect.left;
      } else if (thumbRect.right > railRect.right) {
        thumbnailRail.scrollLeft += thumbRect.right - railRect.right;
      }
    }

    function updateThumbnails() {
      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === currentIndex);
      });
      previewThumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === currentIndex);
      });
      // Update dot navigation
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
      scrollActiveThumbnailIntoView();
    }

    // Event Listeners
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    addSlideIntentListeners(prevBtn, function () {
      return getNavigationBaseIndex() - 1;
    });
    addSlideIntentListeners(nextBtn, function () {
      return getNavigationBaseIndex() + 1;
    });

    thumbnails.forEach((thumbnail) => {
      addSlideIntentListeners(thumbnail, function () {
        return parseInt(thumbnail.getAttribute('data-index'), 10);
      });

      thumbnail.addEventListener('click', function (event) {
        if (suppressThumbnailClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressThumbnailClick = false;
          return;
        }

        const index = parseInt(this.getAttribute('data-index'));
        goToSlide(index, true);
      });
    });

    previewThumbnails.forEach((thumbnail) => {
      if (thumbnail.classList.contains('product-thumbnail-more')) return;

      addSlideIntentListeners(thumbnail, function () {
        return parseInt(thumbnail.getAttribute('data-index'), 10);
      });

      thumbnail.addEventListener('click', function () {
        const index = parseInt(this.getAttribute('data-index'), 10);
        if (!isNaN(index)) {
          goToSlide(index, true);
        }
      });
    });

    // Dot navigation click handlers
    dots.forEach((dot) => {
      addSlideIntentListeners(dot, function () {
        return parseInt(dot.getAttribute('data-index'), 10);
      });

      dot.addEventListener('click', function () {
        const index = parseInt(this.getAttribute('data-index'));
        goToSlide(index, true);
      });
    });

    const toggleBtn = document.querySelector('.thumbnails-toggle');
    const thumbnailMoreBtn = document.querySelector('.product-thumbnail-more');

    function expandThumbnails() {
      if (!thumbnailsWrapper) return;

      thumbnailsWrapper.classList.remove('is-collapsed');
      window.requestAnimationFrame(scrollActiveThumbnailIntoView);
    }

    if (toggleBtn && thumbnailsWrapper) {
      toggleBtn.addEventListener('click', function () {
        const isCollapsed = thumbnailsWrapper.classList.toggle('is-collapsed');
        if (!isCollapsed) {
          window.requestAnimationFrame(scrollActiveThumbnailIntoView);
        }
      });
    }

    if (thumbnailMoreBtn) {
      thumbnailMoreBtn.addEventListener('click', expandThumbnails);
    }

    function startThumbnailDrag(event) {
      if (
        !thumbnailRail ||
        !thumbnailsWrapper ||
        thumbnailsWrapper.classList.contains('is-collapsed') ||
        window.innerWidth <= 991 ||
        thumbnailRail.scrollWidth <= thumbnailRail.clientWidth
      ) {
        return;
      }

      isThumbnailDragging = true;
      thumbnailDragMoved = false;
      thumbnailDragStartX = event.pageX;
      thumbnailDragStartScrollLeft = thumbnailRail.scrollLeft;
      thumbnailRail.classList.add('is-dragging');
    }

    function dragThumbnailRail(event) {
      if (!isThumbnailDragging || !thumbnailRail) return;

      const dragDistance = event.pageX - thumbnailDragStartX;

      if (Math.abs(dragDistance) > 5) {
        thumbnailDragMoved = true;
        suppressThumbnailClick = true;
        event.preventDefault();
      }

      thumbnailRail.scrollLeft = thumbnailDragStartScrollLeft - dragDistance;
    }

    function endThumbnailDrag() {
      if (!isThumbnailDragging || !thumbnailRail) return;

      isThumbnailDragging = false;
      thumbnailRail.classList.remove('is-dragging');

      if (thumbnailDragMoved) {
        window.setTimeout(function () {
          suppressThumbnailClick = false;
        }, 150);
      } else {
        suppressThumbnailClick = false;
      }
    }

    if (thumbnailRail) {
      thumbnailRail.addEventListener('mousedown', startThumbnailDrag);
      thumbnailRail.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
      document.addEventListener('mousemove', dragThumbnailRail);
      document.addEventListener('mouseup', endThumbnailDrag);
    }

    // Drag/Touch functionality
    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function dragStart(event) {
      if (isAnimating) return;
      if (event.type === 'mousedown') {
        event.preventDefault();
      }

      preloadAdjacentSlides(currentIndex, 'high');

      isDragging = true;
      dragStartTime = Date.now();
      startX = getPositionX(event);
      track.classList.add('is-dragging');
    }

    function drag(event) {
      if (!isDragging) return;
    }

    function dragEnd(event) {
      if (!isDragging) return;

      isDragging = false;
      track.classList.remove('is-dragging');

      const endX = event.type.includes('mouse') ? event.pageX : event.changedTouches[0].clientX;
      const dragDuration = Date.now() - dragStartTime;
      const diff = endX - startX;
      const threshold = 50;
      const velocity = Math.abs(diff) / dragDuration;

      if (Math.abs(diff) > threshold || velocity > 0.3) {
        if (diff < 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }

    // Mouse events
    track.addEventListener('mousedown', dragStart);
    track.addEventListener('mousemove', drag);
    track.addEventListener('mouseup', dragEnd);
    track.addEventListener('mouseleave', dragEnd);

    // Touch events
    track.addEventListener('touchstart', dragStart, { passive: true });
    track.addEventListener('touchmove', drag, { passive: true });
    track.addEventListener('touchend', dragEnd);

    // Prevent image dragging
    track.querySelectorAll('img').forEach((img) => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const newSlidesPerView = window.innerWidth > 1364 ? 2 : 1;
        slidesPerView = newSlidesPerView;
        updateSlides();
        syncHeights();
      }, 250);
    });

    // Initialize
    currentIndex = 0;
    updateSlides();
    syncHeights();
    prepareInitialNearbyWarmup();

    function handlePageLoad() {
      syncHeights();
      preloadNearbySlides(currentIndex, 3, 'low');
      loadRemainingGalleryImagesOneByOne();
    }

    if (document.readyState === 'complete') {
      handlePageLoad();
    } else {
      window.addEventListener('load', handlePageLoad);
    }
  });

  (function() {
    var mobileQuery = window.matchMedia('(max-width: 991px)');
    var atcSlot = document.getElementById('pp-add-to-cart-slot');
    var atcWrapper = document.getElementById('pp-add-to-cart-wrapper');
    var atcButton = document.getElementById('add-to-cart-btn');
    var intersectionObserver = null;
    var resizeObserver = null;
    var fallbackScrollActive = false;
    var stateFrame = null;
    var measureFrame = null;
    var observerTopInset = 0;
    var isInline = null;

    if (!atcSlot || !atcWrapper || !atcButton) return;

    if (typeof window.__cleanupPdpStickyAtc === 'function') {
      window.__cleanupPdpStickyAtc();
    }

    function measureButton() {
      measureFrame = null;
      var buttonHeight = Math.ceil(atcButton.getBoundingClientRect().height);
      if (buttonHeight > 0) {
        document.body.style.setProperty('--pp-atc-slot-height', buttonHeight + 'px');
      }
    }

    function scheduleMeasure() {
      if (measureFrame !== null) return;
      measureFrame = window.requestAnimationFrame(function() {
        measureButton();
        if (intersectionObserver && observerTopInset !== getViewportTopInset()) {
          startMobileController();
        } else {
          scheduleStateCheck();
        }
      });
    }

    function setInline(nextInline) {
      if (!mobileQuery.matches || isInline === nextInline) return;
      isInline = nextInline;
      atcWrapper.classList.toggle('is-inline', nextInline);
      document.body.classList.toggle('pp-sticky-atc-fixed', !nextInline);
    }

    function getViewportTopInset() {
      var header = document.querySelector('[data-header-height]');
      return header ? Math.max(0, Math.ceil(header.getBoundingClientRect().height)) : 0;
    }

    function isSlotFullyVisible() {
      var rect = atcSlot.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.height > 0 && rect.top >= getViewportTopInset() - 1 && rect.bottom <= viewportHeight + 1;
    }

    function scheduleStateCheck() {
      if (!mobileQuery.matches || stateFrame !== null) return;
      stateFrame = window.requestAnimationFrame(function() {
        stateFrame = null;
        setInline(isSlotFullyVisible());
      });
    }

    function entryIsFullyVisible(entry) {
      var rootBounds = entry.rootBounds;
      var rect = entry.boundingClientRect;
      var rootTop = rootBounds ? rootBounds.top : 0;
      var rootBottom = rootBounds
        ? rootBounds.bottom
        : (window.innerHeight || document.documentElement.clientHeight);

      return entry.isIntersecting && rect.height > 0 && rect.top >= rootTop - 1 && rect.bottom <= rootBottom + 1;
    }

    function handleFallbackScroll() {
      scheduleStateCheck();
    }

    function startFallbackScroll() {
      if (fallbackScrollActive) return;
      fallbackScrollActive = true;
      window.addEventListener('scroll', handleFallbackScroll, { passive: true });
    }

    function stopFallbackScroll() {
      if (!fallbackScrollActive) return;
      fallbackScrollActive = false;
      window.removeEventListener('scroll', handleFallbackScroll);
    }

    function stopMobileController() {
      if (intersectionObserver) {
        intersectionObserver.disconnect();
        intersectionObserver = null;
      }
      stopFallbackScroll();
      atcWrapper.classList.remove('is-inline');
      document.body.classList.remove('pp-sticky-atc-fixed');
      observerTopInset = 0;
      isInline = null;
    }

    function startMobileController() {
      stopMobileController();
      measureButton();
      setInline(isSlotFullyVisible());

      if ('IntersectionObserver' in window) {
        observerTopInset = getViewportTopInset();
        intersectionObserver = new IntersectionObserver(function(entries) {
          if (!entries.length || !mobileQuery.matches) return;
          setInline(entryIsFullyVisible(entries[0]));
        }, {
          rootMargin: '-' + observerTopInset + 'px 0px 0px 0px',
          threshold: [0, 0.99, 1]
        });
        intersectionObserver.observe(atcSlot);
      } else {
        startFallbackScroll();
      }
    }

    function handleBreakpointChange() {
      if (mobileQuery.matches) {
        startMobileController();
      } else {
        stopMobileController();
      }
    }

    function handleViewportChange() {
      scheduleMeasure();
    }

    function cleanup() {
      stopMobileController();
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', handleViewportChange);
      window.removeEventListener('pageshow', handleViewportChange);
      if (mobileQuery.removeEventListener) {
        mobileQuery.removeEventListener('change', handleBreakpointChange);
      } else if (mobileQuery.removeListener) {
        mobileQuery.removeListener(handleBreakpointChange);
      }
      if (stateFrame !== null) window.cancelAnimationFrame(stateFrame);
      if (measureFrame !== null) window.cancelAnimationFrame(measureFrame);
      document.body.style.removeProperty('--pp-atc-slot-height');
      if (window.__cleanupPdpStickyAtc === cleanup) {
        window.__cleanupPdpStickyAtc = null;
      }
    }

    window.__cleanupPdpStickyAtc = cleanup;
    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('pageshow', handleViewportChange);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(handleBreakpointChange);
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleMeasure);
      resizeObserver.observe(atcButton);
    } else {
      window.addEventListener('load', handleViewportChange, { once: true });
    }

    handleBreakpointChange();
  })();

  window.shareOnFacebook = function () {
    var url = encodeURIComponent(window.location.href);
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, 'facebook-share-dialog', 'width=626,height=436');
  };
  window.shareOnTwitter = function () {
    var url = encodeURIComponent(window.location.href);
    var text = encodeURIComponent(document.title + ' - Check this out!');
    window.open(
      'https://twitter.com/intent/tweet?url=' + url + '&text=' + text,
      'twitter-share-dialog',
      'width=626,height=436'
    );
  };
  window.shareOnPinterest = function () {
    var url = encodeURIComponent(window.location.href);
    var description = encodeURIComponent(document.title);
    var ogImage = document.querySelector('meta[property="og:image"]');
    var imageUrl = ogImage
      ? ogImage.getAttribute('content')
      : document.querySelector('img')
      ? document.querySelector('img').src
      : '';
    window.open(
      'https://pinterest.com/pin/create/button/?url=' +
        url +
        '&description=' +
        description +
        '&media=' +
        encodeURIComponent(imageUrl),
      'pinterest-share-dialog',
      'width=750,height=320'
    );
  };


  function syncProductVariantHiddenIds(variantId) {
    if (!variantId) return;
    ['product-form-variant-id'].forEach(function (hid) {
      var el = document.getElementById(hid);
      if (!el) return;
      el.value = variantId;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateAddToCartButtonsForVariant(radioEl) {
    var details = document.querySelector('.product-details');
    if (!details || !radioEl) return;
    var soldOut = details.getAttribute('data-sold-out-label') || 'Sold out';
    var addCartLabel = details.getAttribute('data-add-cart-label') || 'ADD TO CART';
    var buyNowLabel = details.getAttribute('data-buy-now-label') || 'BUY IT NOW';
    var available = radioEl.getAttribute('data-variant-available') === 'true';
    var addBtn = document.getElementById('add-to-cart-btn');
    var buyBtn = document.getElementById('buy-now-btn');
    var addText = addBtn && addBtn.querySelector('.add-to-bag__text');
    var buyText = buyBtn && buyBtn.querySelector('.buy-now-btn__text');
    if (addBtn) addBtn.disabled = !available;
    if (buyBtn) buyBtn.disabled = !available;
    if (!available) {
      if (addText) addText.textContent = soldOut;
      if (buyText) buyText.textContent = soldOut;
    } else {
      if (addText) addText.textContent = addCartLabel;
      if (buyText) buyText.textContent = buyNowLabel;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('modal');
    var openModalButton = document.getElementById('open-modal');
    var closeModalButton = document.getElementById('close-modal');
    var sizeDisplay = document.getElementById('selected-size-display');

    function loadSizeGuideImages() {
      if (!modal) return;

      modal.querySelectorAll('img[data-src]').forEach(function (image) {
        var src = image.getAttribute('data-src');
        if (!src) return;

        image.setAttribute('src', src);
        image.removeAttribute('data-src');
      });
    }

    if (openModalButton && modal) {
      openModalButton.addEventListener('click', function () {
        loadSizeGuideImages();
        modal.style.display = 'flex';
      });
    }

    if (closeModalButton && modal) {
      closeModalButton.addEventListener('click', function () {
        modal.style.display = 'none';
      });
    }

    if (modal) {
      window.addEventListener('click', function (event) {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      });
    }

    // Size selection (variant id and button labels)
    document.querySelectorAll('input[name="Size"]').forEach(function (size) {
      size.addEventListener('change', function (event) {
        var current = event.target;
        if (sizeDisplay) sizeDisplay.textContent = current.value;

        syncProductVariantHiddenIds(current.getAttribute('data-variant-id'));
        updateAddToCartButtonsForVariant(current);
      });
    });

    var checkedSize = document.querySelector('input[name="Size"]:checked');
    if (checkedSize) {
      syncProductVariantHiddenIds(checkedSize.getAttribute('data-variant-id'));
      updateAddToCartButtonsForVariant(checkedSize);
    }
  });
